import { Pipe, PipeTransform } from '@angular/core';
import { isAfter, isBefore, parseISO, isEqual, isValid } from 'date-fns';

@Pipe({
    name: 'byToSignDate',
    standalone: false
})
export class byToSignDatePipe implements PipeTransform {
  transform(value: any[], ...args: any): any[] {
    args = args[0];
    if (!value || !args || args.length < 3 || !args[0] || !args[1]) {
      return value;
    }
    console.log('yo');

    const startDate = this.parseDate(args[0]);
    const endDate = this.parseDate(args[1]);
    const filterType = args[2];
    console.log('FilterType', filterType);

    if (!isValid(startDate) || !isValid(endDate)) {
      return value;
    }

    return value.filter((item) => {
      let itemDate;
      if (
        filterType === 'or_order_number' ||
        filterType === 'or_assigned_date'
      ) {
        itemDate = this.parseDate(item?.or_assigned_date);
      }

      if (!isValid(itemDate)) {
        return false;
      }

      // Log the dates being compared

      // Check for inclusive range
      return (
        (isAfter(itemDate, startDate) || isEqual(itemDate, startDate)) &&
        (isBefore(itemDate, endDate) || isEqual(itemDate, endDate))
      );
    });
  }

  private parseDate(date: string | Date): Date {
    if (date instanceof Date) {
      return date;
    }

    const parsedDate = parseISO(date);
    return isValid(parsedDate) ? parsedDate : new Date(NaN);
  }
}
